import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

import styles from './index.module.scss';

export const DeviceOptions = ({
  capacities,
  colors,
  selectedCapacity,
  selectedColor,
  variations,
}) => {
  const { t } = useTranslation();
  const router = useRouter();

  const capacityHandler = (id) => {
    const slug = variations?.find(
      (variation) =>
        variation?.storage_id === id &&
        variation?.color_id === selectedColor?.id,
    )?.slug;
    router.push(slug);
  };
  const colorHandler = (id) => {
    const slug = variations?.find(
      (variation) =>
        variation?.color_id === id &&
        variation?.storage_id === selectedCapacity?.id,
    )?.slug;
    router.push(slug);
  };
  const splitVariationsByStorage = () => {
    const storageIds = variations
      ?.filter((variation) => variation?.color_id === selectedColor?.id)
      ?.map((variation) => variation?.storage_id);

    const filteredCapacities = capacities.filter((storage) =>
      storageIds?.includes(storage?.id),
    );

    return filteredCapacities;
  };
  const splitVariationsByColor = () => {
    return colors?.filter((color) => {
      return variations.find(
        (variation) =>
          variation?.color_id === color?.id &&
          variation?.storage_id === selectedCapacity?.id,
      );
    });
  };
  const filteredColors = splitVariationsByColor();
  const filteredStorages = splitVariationsByStorage();
  return (
    <>
      {!!filteredStorages?.length && (
        <div
          className={styles.capacityContainer}
          itemScope
          itemType='https://schema.org/Thing'
        >
          <div>
            <div className={styles.selected}>
              <span>{t('common:Storage')}:</span>
              <span>
                {selectedCapacity?.size} {selectedCapacity?.unit}
              </span>
            </div>
            <div className={styles.options}>
              {filteredStorages?.map((capacityItem) => {
                return (
                  <span
                    key={capacityItem?.id}
                    onClick={() => capacityHandler(capacityItem?.id)}
                    className={classNames(styles.option, {
                      [styles.option__active]:
                        capacityItem?.id === selectedCapacity?.id,
                    })}
                  >
                    {capacityItem?.size} {capacityItem?.unit}
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      )}
      {filteredColors?.length > 1 && (
        <div
          className={styles.colorContainer}
          itemScope
          itemType='https://schema.org/Thing'
        >
          <div>
            <div className={styles.selected}>
              <span>{t('common:Color')}:</span>
              <span> {selectedColor?.title}</span>
            </div>
            <div className={styles.options}>
              {filteredColors?.map((color) => {
                return (
                  <div
                    key={color?.id}
                    onClick={() => colorHandler(color?.id)}
                    className={classNames([
                      styles.colorOption,
                      {
                        [styles.colorOption__active]:
                          color?.id === selectedColor?.id,
                      },
                    ])}
                  >
                    <div
                      className={styles.inside}
                      style={{ backgroundColor: color?.hex_code }}
                    ></div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
